
export class AreaSettings {
  AreaForCriticalAreas: boolean;
}